import React from "react"
import RrssView from "../../../views/commonArea/utilComponentViews/RrssView";

export default function Rrss() {
    return (<RrssView/>)
}